export default __webpack_public_path__ + "resources/icons/n211-ea52.webp";